import { useQuery } from "react-query";
import { getJob } from "services/job.service";

export default function useJob(jobId: string) {
  return useQuery(["job", jobId], async () => await getJob(jobId), {
    enabled: jobId ? true : false,
  });
}
